import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConstants } from "src/shared/AppConstants";
import { Feedback, Feedback_Form_Details, Feedback_Profile_Details, Publications, Resources, Save_Feedback_Form_Details, SearchSiteDetails } from "../_models/publications";
import { FILE_ICON_TYPE, FileStoreType } from "../_enums/constant-types.enum";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { APIResponse } from "../_models/apiResponse";
import { PortalProfiles } from "../_models/portals";

@Injectable({
  providedIn: 'root'
})

export class PublicationsService {

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  getPublicationsList(ProfileId: string): Observable<Array<Publications>> {
    return this.http.get<Array<Publications>>(AppConstants.PortalApiBaseUrl + '/api/Publications/GetPortalProfilePubsList/' + AppConstants.EnvironmentId + '/' + ProfileId);
  }

  getFileType(ext: string): string {
    let type: string = FILE_ICON_TYPE.OTHER;
    if (ext) {
      switch (ext.toLowerCase()) {
        case ".pdf":
          type = FILE_ICON_TYPE.PDF;
          break;
        case ".doc":
        case ".docx":
          type = FILE_ICON_TYPE.WORD;
          break;
        case ".htm":
        case ".html":
          type = FILE_ICON_TYPE.HTML;
          break;
        case ".ppt":
        case ".pptx":
          type = FILE_ICON_TYPE.PPT;
          break;
        case ".xls":
        case ".xlsx":
          type = FILE_ICON_TYPE.XLS;
          break;
        case ".bmp":
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".gif":
          type = FILE_ICON_TYPE.IMAGE;
          break;
        case ".mp4":
        case ".mov":
          type = FILE_ICON_TYPE.VIDEO;
          break;
        default:
          type = FILE_ICON_TYPE.OTHER;
          break;
      }
    }
    return type;
  }

  getURL(id: string, storeType: FileStoreType): string {
    return AppConstants.PortalApiBaseUrl + '/api/File/Preview?type=' + storeType + '&id=' + id;
  }

  downloadURL(id: string, storeType: FileStoreType): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(AppConstants.PortalApiBaseUrl + '/api/File/Download?type=' + storeType + '&id=' + id); 
  }

  getDownloadURL(id: string, storeType: FileStoreType): string {
    return AppConstants.PortalApiBaseUrl + '/api/File/Download?type=' + storeType + '&id=' + id;
  }

  isMobile(): boolean {
    const regex = /Mobi|Android|webOS|iPhone|Tablet|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
  }

  isIphoneMobile(): boolean {
    const regex = /Mobi|iPhone|Tablet|iPad|iPod/i;
    return regex.test(navigator.userAgent);
  }

  getSearchSiteList(searchSiteDetails: SearchSiteDetails): Observable<SearchSiteDetails> {
    searchSiteDetails.Environment_Id = AppConstants.EnvironmentId;
    return this.http.post<SearchSiteDetails>(AppConstants.PortalApiBaseUrl + '/api/Publications/GetSearchResults', searchSiteDetails );
  }

  /*Resources Service
  */
  getResourcesList(ProfileId: string): Observable<Array<Resources>> {
    return this.http.get<Array<Resources>>(AppConstants.PortalApiBaseUrl + '/api/Resources/GetPortalResourcesList/' + AppConstants.EnvironmentId + '/' + ProfileId);
  }

  /**
   * Feedback Questions API Calls
   */
  getFeedbackQuestsList(ProfileId: string): Observable<Array<Feedback>> {
    return this.http.get<Array<Feedback>>(AppConstants.PortalApiBaseUrl + '/api/Fdbk/GetPortalsFeedbackList/' + AppConstants.EnvironmentId + '/' + ProfileId);
  }

  saveFeedbackFormData(FdbkForm: Array<Save_Feedback_Form_Details>, selectedFdbkProfile: Feedback_Profile_Details, profileinfo: PortalProfiles): Observable<APIResponse> {
    let fdbkFormData: Feedback_Form_Details = {
      Environment_Id: AppConstants.EnvironmentId ?? "",
      Profile_Id: profileinfo.PK_ENV_PROFILE_ID,
      Profile_Name: profileinfo.NAME,
      Profile_Code: selectedFdbkProfile.Fdbk_Profile_Code,
      feedbackFormList: [],
    }
    fdbkFormData.feedbackFormList = FdbkForm;
    return this.http.post<APIResponse>(AppConstants.PortalApiBaseUrl + '/api/Fdbk/SaveFeedbackFormDetails', fdbkFormData );
  }

  getFeedbackProfilesList(): Observable<Array<Feedback_Profile_Details>> {
    return this.http.get<Array<Feedback_Profile_Details>>(AppConstants.PortalApiBaseUrl + '/api/Fdbk/GetFeedbackPortalsList/' + AppConstants.EnvironmentId);
  }
}
